<template>
  <div id="loading-bg" style="background: #0c182b !important;">
    <div class="loading-logo text-center">
      <img src="/logo-white2.png" alt="Logo"/>
    </div>
    <div class="loading-login flex items-center justify-center">
      <Icon icon="arcticons:sqrllogin" height="48" class="text-white"/>
      <div class="effect-1 effects"></div>
      <div class="effect-2 effects"></div>
      <div class="effect-3 effects"></div>
    </div>
  </div>
</template>

<script setup>
import {useRoute} from "vue-router";
import {useUserStore} from "@/stores/user.js";
import router from "@/router/index.js";
import {onMounted} from "vue";
import {Icon} from "@iconify/vue";
import {createAbility} from "@/services/ability.js";
import {useAbility} from '@casl/vue';

const route = useRoute();
const ability = useAbility();
const discordCode = route.query.code;
const userStore = useUserStore()

async function loginWithDiscord() {
  await userStore.action_loginWithDiscord({code: discordCode});
  const loggedIn = userStore.getCredential;
  if (loggedIn) {
    const newAbilities = createAbility(userStore.getPermissions);
    ability.update(newAbilities);
    await router.push({name: "Dashboard"});
  }
}

onMounted(async () => {
  await loginWithDiscord();
})


</script>

<style scoped lang="scss">

</style>